module.exports = "/glooko-logo1367d673535ed4ebc462fc8e32b78489.svg";